module.exports = __webpack_public_path__ + "img/messageboard-third-section_600.baa92cfa.png";